<template lang="html">
  <div class="home-articles-body">
    <div
      v-for="(item, index) in list"
      @click="jump(item.art_url)"
      class="each"
      :key="index"
    >
      <div class="wrapper">
        <div class="left">
          <p>{{ item.title }}</p>
          <div class="desc">
            <!-- <span class="author">{{item.author_name}}</span> -->
            <span class="read">{{ item.read_num | maxTenThousand }}人学习</span>
          </div>
        </div>
        <div class="right">
          <img
            v-lazy="
              item.cover_path
                ? $$viewImage(item.cover_path, 218, 152)
                : imgDefault
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgDefault from '@/assets/images/yuerdx_default@3x.png'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      imgDefault
    }
  },
  filters: {
    maxTenThousand(value) {
      if (value) {
        if (+value > 9999) {
          return `${(+value / 10000).toFixed(1)}w`
        } else {
          return value
        }
      } else {
        return 0
      }
    }
  },
  methods: {
    jump(url) {
      this.trackClick(200032, {}, '', 121011908)
      location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.each {
  padding: 0 rem(30px);
  &:first-child {
    margin-top: rem(-30px);
  }
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: rem(32px) 0;
    padding-bottom: rem(40px);
    border-bottom: rem(1px) solid #eee;
  }
  &:last-child {
    .wrapper {
      border: none;
    }
  }
  .left {
    width: rem(436px);
    height: rem(152px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      word-wrap: break-word;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: rem(32px);
      font-weight: 500;
      color: #333;
      letter-spacing: 0;
      line-height: rem(48px);
    }
    .desc {
      // margin-top: rem(23px);
      display: flex;
      justify-content: space-between;
      span {
        font-size: rem(24px);
        color: #999999;
        letter-spacing: 0;
        line-height: rem(30px);
      }
    }
  }
  .right {
    width: rem(218px);
    height: rem(152px);
    overflow: hidden;
    flex: none;
    border-radius: rem(12px);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
